/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=151b2728&scoped=true&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=151b2728&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b2728",
  null
  
)

export default component.exports